import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AccessControlDirective } from 'src/app/shared/directives/access-control.directive';
import { BillingApiResponse, BillingDialogConfig } from 'src/app/shared/interface/billing.interface';
import { CommonApiResponse } from 'src/app/shared/interface/common.interface';
import { BillingService } from 'src/app/shared/services/billing.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-billing-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, CurrencyPipe, AccessControlDirective],
  templateUrl: './billing-dialog.component.html',
  styleUrl: './billing-dialog.component.scss',
})
export class BillingDialogComponent {
  config: BillingDialogConfig | undefined;
  dynamicData!: BillingApiResponse;

  constructor(
    private dialogRef: MatDialogRef<BillingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: CommonApiResponse<BillingApiResponse>,
    private billingService: BillingService
  ) {}

  ngOnInit() {
    this.config = this.billingService.getBillingDialogConfigFromApiResponse(this.dialogData);
    this.dynamicData = this.dialogData?.data;
  }

  onActionClick(actionType: string) {
    switch (actionType) {
      case 'cancel':
        this.dialogRef.close();
        break;
      case 'continue':
        this.dialogRef.close({ proceed: true });
        break;
      case 'createOrder':
        this.dialogRef.close({ proceed: true });
        break;
      case 'addPaymentMethod':
        window.location.href = `${environment.portal.frontendBaseUrl}/app/addCompany/payment/${this.dynamicData?.companyId}`;
        this.dialogRef.close();
        break;
    }
  }
}
